import { CompletionsAreaTeamBase } from './base/completions-area-team-base';

export class CompletionsAreaTeam extends CompletionsAreaTeamBase { }